import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/header/header-bg.png'
import _imports_1 from '../assets/campain.png'


const _withScopeId = n => (_pushScopeId("data-v-00764089"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-[210px] md:h-[420px] flex flex-row md:k-items-center items-center md:justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-[40%] flex flex-col gap-2 pl-4 text-fmfm-text drop-shadow-lg" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "md:text-5xl k-text-lg flex flex-start flex-col md:gap-4" }, [
      /*#__PURE__*/_createElementVNode("div", null, "株探が最強の"),
      /*#__PURE__*/_createElementVNode("div", null, "情報収集ツールに"),
      /*#__PURE__*/_createElementVNode("div", null, "生まれ変わる"),
      /*#__PURE__*/_createElementVNode("div", { class: "md:text-3xl text-xs mt-4 justify-start flex flex-col md:gap-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, "ユーザー数 800人突破"),
        /*#__PURE__*/_createElementVNode("div", null, "株探ユーザー必見!!")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "relative w-[60%] h-full flex justify-center items-center flex-col gap-2" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "absolute z-9 h-[140px] md:h-[360px]",
      src: _imports_0,
      alt: "pair look"
    })
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative md:mt-8 mt-4" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_view = _resolveComponent("header-view")!
  const _component_section_row = _resolveComponent("section-row")!
  const _component_trial_button = _resolveComponent("trial-button")!
  const _component_youtube_view = _resolveComponent("youtube-view")!
  const _component_price_view = _resolveComponent("price-view")!
  const _component_cancel_view = _resolveComponent("cancel-view")!
  const _component_function_view = _resolveComponent("function-view")!
  const _component_installation_guide = _resolveComponent("installation-guide")!
  const _component_question_view = _resolveComponent("question-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_section_row, { isHeader: true }, {
      default: _withCtx(() => [
        _createVNode(_component_header_view)
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, {
      isHeader: true,
      bgColor: 'bg-gradient-to-r from-blue-gradient-start to-blue-gradient-end'
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_trial_button, {
          value: _ctx.startButtonText,
          isPremiumUser: _ctx.isPremiumUser,
          onSubscription: _ctx.subscription
        }, null, 8, ["value", "isPremiumUser", "onSubscription"])
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, { bgColor: 'bg-cyan-50' }, {
      default: _withCtx(() => [
        _createVNode(_component_youtube_view, {
          title: '株探拡張Proの全ての機能をチェックする',
          subTitle: '2分ください!',
          url: 'https://www.youtube.com/embed/yb7COIwGYdA?si=EDUi2DDkHFabrE8a&controls=0?autoplay=1&mute=1'
        }, null, 8, ["url"])
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_price_view)
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, { bgColor: 'bg-cyan-50' }, {
      default: _withCtx(() => [
        _createVNode(_component_cancel_view),
        _createVNode(_component_trial_button, {
          value: _ctx.startButtonText,
          isPremiumUser: _ctx.isPremiumUser,
          onSubscription: _ctx.subscription
        }, null, 8, ["value", "isPremiumUser", "onSubscription"])
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_function_view)
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, { bgColor: 'bg-cyan-50' }, {
      default: _withCtx(() => [
        _createVNode(_component_installation_guide)
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_question_view)
      ]),
      _: 1
    }),
    _createVNode(_component_section_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_trial_button, {
          value: _ctx.startButtonText,
          isPremiumUser: _ctx.isPremiumUser,
          onSubscription: _ctx.subscription
        }, null, 8, ["value", "isPremiumUser", "onSubscription"])
      ]),
      _: 1
    })
  ], 64))
}